var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"agency-level-selector",attrs:{"items":_vm.options,"disabled":_vm.disabled,"hide-details":"","dark":"","menu-props":{
		bottom: true,
		offsetY: true,
		contentClass: 'agency-level-selector__menu-content'
	}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }